import { ReactNode } from 'react';

export default function SubmissionWrapper({ perPageDropDownComponent, children, paginationComponent, title }: { perPageDropDownComponent: JSX.Element; children: ReactNode; paginationComponent: ReactNode; title: JSX.Element }) {
  return (
    <div className='flex h-[inherit] bg-[#F9FAFB] w-full rightside-math-a-palooza'>
      <div className=' min-h-screen h-full relative rounded  pt-10 w-full flex justify-between flex-col'>
        <div className='pb-4'>
          {title}
          <div className='px-10 grid md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-4'>{children}</div>
        </div>
        <div className='w-full px-4 py-2 bg-white flex justify-center items-center max-lg:justify-start'>
          <div className='flex-1 inline-flex justify-center max-lg:justify-start max-md:justify-center'>
            <div className='[&_li>a]:h-8 [&_li>a]:w-16'>{paginationComponent}</div>
          </div>
          <div className='perpage-wrap justify-end md:absolute md:right-2 max-md:!hidden'>{perPageDropDownComponent}</div>
        </div>
      </div>
    </div>
  );
}
